import React from 'react';
import './editor.scss';
import { PanelBody, PanelRow, TextControl, Button } from '@wordpress/components';
import {
	MediaUpload,
	useBlockProps,
	InspectorControls,
} from '@wordpress/block-editor';

export default function Edit( { attributes, setAttributes } ) {
	const { title, image_id, image, link } = attributes;

	const onSelectImage = (media) => {
		setAttributes({
		  image_id: media.id,
		  image: media.url,
		});
	};

	return (
		<div { ...useBlockProps() }>
			<InspectorControls key="setting">
				<PanelBody title="Configurações do Banner" initialOpen={true}>
					<PanelRow>
						<TextControl
							label="Título"
							placeholder='Título do Banner'
							value={title}
							onChange={(value) => setAttributes({ title: value })}
						/>
					</PanelRow>
					<PanelRow>
						<TextControl
							label="Link"
							placeholder='Link'
							value={link}
							onChange={(value) => setAttributes({ link: value })}
						/>
					</PanelRow>					
				</PanelBody>
			</InspectorControls>
			<MediaUpload
				onSelect={onSelectImage}
				allowedTypes={['image']}
				value={image_id}
				render={({ open }) => (
				<Button onClick={open} className="button button-large">
					{image ? <img src={image} alt="Banner" style={{ maxWidth: '100%' }} /> : 'Selecionar imagem'}
				</Button>
				)}
			/>
		</div>
	);
}